<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="_idContainer1347">
<p class="structure-imgs1"><img alt="" class="_idgenobjectattribute5" src="OEBPS/image/image-220.png"/></p>
<div class="calibre1" id="calibre_pb_40"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5Ingredient_split_023.vue?671b00fe